import React from 'react';

const PriorYearPayrollValueTooltip = ({ position }) => {
  return (
    <div 
      style={{
        position: 'fixed',
        top: `${position.y}px`,
        left: `${position.x}px`,
        zIndex: 10000,
        background: '#555',
        color: 'white',
        padding: '10px',
        borderRadius: '6px',
        fontSize: '14px',
        maxWidth: '300px',
        wordWrap: 'break-word',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
      }}
    >
      A value was entered in this field last year. Please verify if this year's entry is complete.
    </div>
  );
};

export default PriorYearPayrollValueTooltip;